module.exports = __webpack_public_path__ + "static/media/menu-dots.cb542bca.svg";